var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactFormRoads(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 29,
    viewBox: "0 0 35 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8728 0.488699C20.7736 0.290327 20.57 0.165039 20.3507 0.165039H14.3108C14.0863 0.165039 13.888 0.290327 13.7888 0.488699L0.393392 27.3316C0.304646 27.5143 0.315112 27.7284 0.419519 27.9006C0.523926 28.0729 0.717057 28.1773 0.92065 28.1773H33.7461C33.9497 28.1773 34.1376 28.0729 34.2472 27.9006C34.3517 27.7284 34.3621 27.5143 34.2733 27.3316L20.878 0.488699H20.8728ZM21.0241 27.008H1.86553L14.6762 1.33961H15.95L15.809 2.91615L16.3937 2.96836L16.5399 1.33961H18.1321L18.2782 2.96836L18.8629 2.91615L18.722 1.33961H19.9958L32.8064 27.008H21.0241Z",
    fill: "#CC7D61"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9441 12.4053L14.7472 14.5942L15.3295 14.6466L15.5264 12.4577L14.9441 12.4053Z",
    fill: "#CC7D61"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2035 9.48685L15.0066 11.6758L15.5889 11.7282L15.7858 9.53923L15.2035 9.48685Z",
    fill: "#CC7D61"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.729 3.64212L15.5321 5.83105L16.1144 5.88344L16.3113 3.6945L15.729 3.64212Z",
    fill: "#CC7D61"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4691 6.56449L15.2722 8.75342L15.8545 8.8058L16.0514 6.61687L15.4691 6.56449Z",
    fill: "#CC7D61"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6841 15.3238L14.4872 17.5127L15.0696 17.5651L15.2665 15.3761L14.6841 15.3238Z",
    fill: "#CC7D61"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8945 24.0869L13.6976 26.2759L14.28 26.3283L14.4769 24.1393L13.8945 24.0869Z",
    fill: "#CC7D61"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1602 21.1685L13.9633 23.3574L14.5456 23.4098L14.7425 21.2209L14.1602 21.1685Z",
    fill: "#CC7D61"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4253 18.2461L14.2284 20.4351L14.8107 20.4874L15.0076 18.2985L14.4253 18.2461Z",
    fill: "#CC7D61"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7582 24.0843L20.1759 24.1367L20.3728 26.3256L20.9551 26.2733L20.7582 24.0843Z",
    fill: "#CC7D61"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4977 21.1639L19.9154 21.2163L20.1123 23.4052L20.6946 23.3528L20.4977 21.1639Z",
    fill: "#CC7D61"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4405 9.48668L18.8582 9.53906L19.0551 11.728L19.6374 11.6756L19.4405 9.48668Z",
    fill: "#CC7D61"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7061 12.4061L19.1238 12.4585L19.3207 14.6474L19.903 14.595L19.7061 12.4061Z",
    fill: "#CC7D61"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2321 18.2406L19.6498 18.293L19.8467 20.4819L20.429 20.4295L20.2321 18.2406Z",
    fill: "#CC7D61"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M19.18 6.56237L18.5977 6.61475L18.7946 8.80367L19.3769 8.75129L19.18 6.56237Z",
    fill: "#CC7D61"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9196 3.64781L18.3373 3.7002L18.5342 5.88912L19.1165 5.83674L18.9196 3.64781Z",
    fill: "#CC7D61"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9489 15.3588L19.3666 15.4111L19.5635 17.6001L20.1458 17.5477L19.9489 15.3588Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactFormRoads);
export default __webpack_public_path__ + "static/media/contact-form-roads.5d5e8125e182a66e47f77817ef213545.svg";
export { ForwardRef as ReactComponent };